"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../../../../");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var styles = require("./FooterLinks.css");
require("./FooterLinks.mobile.css");
var utils_1 = require("../../../../../utils/utils");
var FooterLinksDataContent_1 = require("./FooterLinksDataContent");
var MotionPoint_1 = require("./MotionPoint");
var cssClasses = [styles.footerLinks];
var mp;
var FooterLinks = /** @class */ (function (_super) {
    __extends(FooterLinks, _super);
    function FooterLinks(props) {
        var _this = _super.call(this, props) || this;
        mp = new MotionPoint_1.default();
        mp.init();
        _this.languageLinkClick = _this.languageLinkClick.bind(_this);
        _this.links = FooterLinksDataContent_1.default.links.map(function (linkData, index) { return (React.createElement("div", { key: index },
            React.createElement(__1.Link, { data: linkData, title: "A new window" }))); });
        return _this;
    }
    FooterLinks.prototype.languageLinkClick = function (e) {
        // const lang = document.getElementById('ge5p_z1-change-language').getAttribute('data-lang');
        // const url = document.getElementById('ge5p_z1-change-language').getAttribute('data-href');
        // MP.switchLanguage(MP.tSite === url ? MP.oSite : url, lang);
        mp.languageClick(e);
    };
    FooterLinks.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: cssClasses.join(' ') },
            React.createElement("div", { className: styles.links },
                React.createElement("div", { className: styles.linkColumns }, this.links.slice(0, 4)),
                React.createElement("div", { className: styles.linkColumns },
                    this.links.slice(4, 8),
                    React.createElement("div", { style: { display: 'none' } },
                        React.createElement("a", { className: "langLink", id: "ge5p_z1-change-language", "data-href": "javascript:void(0);", href: "javascript:void(0);", "data-lang": "es", onClick: this.languageLinkClick }, "Ver en espa\u00F1ol")))),
            React.createElement("div", null,
                React.createElement("span", { className: styles.copyRightIntellectual },
                    React.createElement(__1.Link, { testId: utils_1.default(this.props.testId, 'Link'), className: styles.copyRights, data: FooterLinksDataContent_1.default.copyrightLink, title: "A new window" })),
                "\u00A0",
                React.createElement(__1.Label, { testId: this.props.testId ? this.props.testId + "_Label" : null, data: { text: 'All rights reserved.' }, options: { size: LabelProps_1.LabelSizes.SMALL, className: styles.copyRights } })),
            React.createElement("div", { className: styles.trustImage },
                React.createElement("a", { href: FooterLinksDataContent_1.default.trusteLink.href, target: FooterLinksDataContent_1.default.trusteLink.target, title: "A new window" },
                    React.createElement(__1.Image, { testId: this.props.testId ? this.props.testId + "_Image" : null, data: {
                            url: FooterLinksDataContent_1.default.trusteLogo,
                        }, options: { alt: FooterLinksDataContent_1.default.trusteLink.content, height: '33px', width: '106px' } })))));
    };
    return FooterLinks;
}(React.Component));
exports.default = FooterLinks;
//# sourceMappingURL=FooterLinks.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/FooterLinks.js
// module id = 1382
// module chunks = 8